
import { BUTTON_STYLES } from "../../styles/buttonStyles";
import { THEME_COLORS, FONT_FAMILY, FONT_SIZE } from "../../util/themes";

// Función para generar estilos de campo con tema dinámico
export const getCouponFieldStyle = (theme: any) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    pr: 0,
    backgroundColor: theme.colors.background.paper,
    color: theme.colors.text.primary,
    '& fieldset': { border: `1px solid ${theme.colors.greyLight}` },
    '&:hover fieldset': { border: `1px solid ${theme.colors.greyLight}` },
    '&.Mui-focused fieldset': { border: `1px solid ${theme.colors.greyLight}` },
  },
  '& .MuiInputLabel-root': {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    color: theme.colors.text.secondary,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.colors.text.secondary,
  },
  '& .MuiOutlinedInput-input': {
    color: theme.colors.text.primary,
  },
});

// Mantener el estilo original para compatibilidad con código existente (tema claro)
export const couponFieldStyle = getCouponFieldStyle({ colors: THEME_COLORS });

// Función para generar estilos de botón de cupón dinámicamente
export const getCouponButtonStyle = (theme: any) => ({
  mt: 2,
  borderRadius: 0,
  borderColor: theme.colors.greyLight,
  color: theme.colors.text.primary,
  fontFamily: FONT_FAMILY.primary,
  fontWeight: '400',
  textTransform: 'none',
  '&:hover': {
    borderColor: theme.colors.greyLight,
    backgroundColor: theme.colors.background.paper,
    color: theme.colors.text.secondary,
  }
});

// Función para generar estilos de contenedor de cupón aplicado
export const getCouponAppliedContainerStyleMobile = (theme: any) => ({
  ...getCouponAppliedContainerStyle(),
  border: `1px solid ${theme.colors.greyLight}`,
  padding: '5px 15px'
});

// Función para generar estilos de contenedor de cupón aplicado
export const getCouponAppliedContainerStyle = () => ({
  mt: 2
});

export const couponButtonStyle = getCouponButtonStyle({ colors: THEME_COLORS });

export const couponAppliedContainerStyle = getCouponAppliedContainerStyle();

export const couponAppliedContainerStyleMobile = getCouponAppliedContainerStyleMobile({ colors: THEME_COLORS });


export const getCouponDeleteButtonStyle = (theme: any) => ({
  color: theme.colors.text.primary,
  '&:hover': {
    color: theme.colors.text.secondary,
    opacity: 0.8
  }
});

export const couponDeleteButtonStyle = getCouponDeleteButtonStyle({ colors: THEME_COLORS });

export const couponSubmitButtonStyle = {
  ...BUTTON_STYLES.icon
};

export const priceRowStyle = { 
  display: "flex", 
  justifyContent: "space-between" 
};

export const priceLabelStyle = { 
  fontFamily: FONT_FAMILY.primary, 
  fontSize: FONT_SIZE.base, 
  color: THEME_COLORS.primary 
};

export const priceValueStyle = { 
  fontFamily: FONT_FAMILY.primary, 
  fontSize: FONT_SIZE.base, 
  color: THEME_COLORS.primary 
};

export const discountLabelStyle = { 
  color: THEME_COLORS.secondary, 
  fontSize: FONT_SIZE.base, 
  mb: 1,
  fontFamily: FONT_FAMILY.primary,
  maxWidth: '70%'
};

export const discountValueStyle = { 
  color: THEME_COLORS.secondary, 
  fontSize: FONT_SIZE.base, 
  fontFamily: FONT_FAMILY.primary
};

export const totalLabelStyle = { 
  fontFamily: FONT_FAMILY.primary, 
  color: THEME_COLORS.secondary, 
  fontSize: '22px', 
  fontWeight: 400 
};

export const totalValueStyle = { 
  fontFamily: FONT_FAMILY.primary, 
  color: THEME_COLORS.secondary, 
  fontSize: '22px', 
  fontWeight: 400 
};

export const breadcrumbActiveStyle = {
  fontFamily: FONT_FAMILY.primary,
  fontSize: FONT_SIZE.sm,
  color: THEME_COLORS.primary,
  fontWeight: "bold",
};

export const breadcrumbInactiveStyle = {
  fontFamily: FONT_FAMILY.primary,
  fontSize: FONT_SIZE.sm,
  color: THEME_COLORS.overlay.light,
};

export const sectionTitleStyle = {
  fontFamily: FONT_FAMILY.primary,
  textAlign: 'center',
  fontSize: '30px',
  color: THEME_COLORS.primary,
  fontWeight: 'bold',
  mb: 2
};

export const checkboxStyle = {
  color: THEME_COLORS.primary,
  '&.Mui-checked': { color: THEME_COLORS.primary },
};

export const checkboxLabelStyle = {
  '& .MuiTypography-root': {
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    color: THEME_COLORS.overlay.light,
  }
};

export const textFieldStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    fontFamily: FONT_FAMILY.primary,
    fontSize: FONT_SIZE.sm,
    height: "40px",
    '& fieldset': { border: `1px solid ${THEME_COLORS.greyLight}` },
    '&:hover fieldset': { border: `1px solid ${THEME_COLORS.greyLight}` },
    '&.Mui-focused fieldset': { border: `1px solid ${THEME_COLORS.greyLight}` },
  },
};

export const zipCodeLinkStyle = {
  fontSize: FONT_SIZE.sm,
  fontFamily: FONT_FAMILY.primary,
  color: THEME_COLORS.secondary,
  textDecoration: "none",
  cursor: "pointer",
  whiteSpace: 'nowrap',
  pr: 1,
  '&:hover': { color: "#5a6c6d" }
};

export const continueButtonStyle = {
  ...BUTTON_STYLES.primary
};

export const productListStyle = { 
  maxHeight: '300px', 
  overflow: 'auto',
  '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
  '&::-webkit-scrollbar-thumb': { 
    background: '#c1c1c1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': { background: '#a8a8a8' },
};

export const productItemStyle = { 
  display: "flex", 
  justifyContent: "space-between", 
  mb: 2,
  alignItems: 'center'
};

export const productInfoStyle = { 
  display: 'flex', 
  alignItems: 'center', 
  gap: 2,
};

export const productImageStyle = {
  width: 60,
  height: 80,
  objectFit: 'cover',
};

export const productNameStyle = { 
  fontFamily: FONT_FAMILY.primary, 
  fontSize: FONT_SIZE.base, 
  color: THEME_COLORS.primary 
};

export const productPriceStyle = { 
  fontFamily: FONT_FAMILY.primary, 
  fontSize: FONT_SIZE.base, 
  color: THEME_COLORS.primary,
  mr: 2 
};

export const mainContainerStyle = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: 3.75,
  p: { xs: 2, md: 4 },
  position: 'relative',
  mt: { xs: 0, md: 0 }
};

export const leftColumnStyle = { 
  flex: 2, 
  pr: { md: '30px' } 
};

export const rightColumnStyle = { 
  flex: 1 
};














